import { Major } from './../../builders/major_builder';

export class MajorsListController {
  selectedMajorsPerCategory(majors: Major[]): number {
    const count = _.countBy(majors, (major) => {
      return major.isSelected;
    });
    return count.true;
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngMajorsListController', MajorsListController)
  .component('majorsList', {
    controller: 'ngMajorsListController',
    templateUrl: 'lib/transfer/components/majors_list/majors_list.html',
    controllerAs: '$ctrl',
    bindings: {
      majorCategoryList: '<'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/majors_list/majors_list.ts